import EditLimits from "@/components/popups/EditLimits";
import ActiveTest from "@/components/shared/ActiveTest";
import NetworkTest from "@/components/shared/NetworkTest";
import SpeechSynthesis from "@/mixins/SpeechSynthesis";
import { navigationNamespace } from "@/store/modules/navigation";
import { patientNamespace } from "@/store/modules/patient";
import { Patient } from "@/store/modules/patient/types";
import { Permission, userNamespace } from "@/store/modules/user";
import {
  Preference,
  PreferenceKeys,
  TemperatureTypes
} from "@/store/modules/user/types";
import _ from "lodash";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import {
  acuityLevels,
  AUDIO_ALERTS_ENABLED_TEXT,
  TESTING_AUDIO_TEXT
} from "../shared/util";

@Component({
  components: { ActiveTest, EditLimits, NetworkTest }
})
export default class Settings extends mixins(SpeechSynthesis) {
  @Action("goHome", navigationNamespace)
  goHome!: Function;

  @Action("darkMode", navigationNamespace)
  setDarkMode!: Function;

  @Action("updateSettings", patientNamespace)
  updateSettings!: Function;

  @Action("setPreference", userNamespace)
  setPreference!: (preference: Preference) => void;

  @Action("setAudioAlertsEnabled", userNamespace)
  setAudioAlertsEnabled!: Function;

  @Action("setAlertRepeatInterval", userNamespace)
  setAlertRepeatInterval!: Function;

  @Action("toggleMaskSetting", userNamespace)
  toggleMaskSetting!: Function;

  @Getter("isPermanentMask", userNamespace)
  isPermanentMask!: boolean;

  @Getter("isMask", userNamespace)
  isMask!: boolean;

  @Getter("darkMode", navigationNamespace)
  dark!: boolean;

  @Getter("vars", patientNamespace)
  vars!: any;

  @Getter("inWrapper", navigationNamespace)
  inWrapper!: boolean;

  @Getter("current", patientNamespace)
  current!: Patient;

  @Getter("minDataPatient", patientNamespace)
  minDataPatient!: boolean;

  @Getter("isTesting", patientNamespace)
  isTesting!: boolean;

  @Getter("towerMode", patientNamespace)
  towerMode!: boolean;

  @Getter("serverTowerMode", patientNamespace)
  serverTowerMode!: boolean;

  @Action("toggleMode", patientNamespace)
  toggleMode!: Function;

  @Getter("area", patientNamespace)
  area!: string;

  @Getter("audioAlertsEnabled", userNamespace)
  audioAlertsEnabled!: boolean;

  @Getter("alertRepeatInterval", userNamespace)
  alertRepeatInterval!: number;

  @Getter("canEdit", userNamespace)
  canEdit!: boolean;

  @Getter("isActiveTest", patientNamespace)
  isActiveTest!: boolean;

  @Getter("demo", userNamespace)
  demo!: boolean;

  @Getter("user", userNamespace)
  user!: any;

  get isUserTower() {
    return this.user.rights.includes(Permission.TOWER);
  }

  get isPatientView() {
    return this.$route.params["room"] != null;
  }

  @Getter("preferenceTemperature", userNamespace)
  preferenceTemperature!: string;

  updatePreferenceTemperature(value: TemperatureTypes) {
    this.setPreference({
      key: PreferenceKeys.TEMPERATURE,
      value
    });
  }

  acuityLevels: Array<any> = [];
  acuityLevel = 0;
  saving = false;

  isMaskButtonDisabled = false;

  get audioIcon() {
    if (this.audioAlertsEnabled) {
      return "volume_up";
    } else {
      return "volume_off";
    }
  }

  get audioText() {
    if (this.audioAlertsEnabled) {
      return "enabled";
    } else {
      return "off";
    }
  }

  get audioColor() {
    if (this.audioAlertsEnabled) {
      return "success";
    } else {
      return "error";
    }
  }

  get isShowingTesting() {
    return this.isTesting;
  }
  get censusRoute() {
    return this.$route.name === "census";
  }

  set alertRepeatIntervalModel(value: number) {
    this.setAlertRepeatInterval(value);
  }
  get alertRepeatIntervalModel() {
    return this.alertRepeatInterval;
  }

  get alertRepeatIntervalOptions() {
    const repeatOptions = [
      {
        text: "Never repeat",
        value: 0
      }
    ];
    for (let i = 5; i <= 30; i += 5) {
      repeatOptions.push({ text: `${i} minutes`, value: i });
    }
    return repeatOptions;
  }

  toggleAudio() {
    this.setAudioAlertsEnabled(!this.audioAlertsEnabled);
    if (this.audioAlertsEnabled) {
      this.setSpeechSynthesisEnabled(true);
      this.speak(AUDIO_ALERTS_ENABLED_TEXT);
    }
  }

  toggleTower() {
    this.toggleMode("tower");
  }

  testAudio() {
    this.speak(TESTING_AUDIO_TEXT);
  }

  updateLevel(newValue: number) {
    this.acuityLevel = newValue;
    this.saving = true;

    const finish = () => {
      this.saving = false;
    };
    if (this.demo) {
      finish();
    } else {
      this.updateSettings({
        id: this.current.id,
        settings: { AcuityLevel: this.acuityLevel }
      }).then(finish);
    }
  }

  mounted() {
    this.acuityLevel = _.get(
      this,
      "current.body.current.AcuityLevel.value",
      null
    );
    this.acuityLevels = acuityLevels;
  }

  toggleMask() {
    this.isMaskButtonDisabled = true;
    this.toggleMaskSetting();
    this.isMaskButtonDisabled = false;
  }
}
